import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const InputWrapper = styled.div`
    position: relative;
`;

export const DollarSign = styled.span`
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    pointer-events: none;
    color: rgba(255, 255, 255, 0.5);
`;

export const DollarInput = styled.input`
    ${styledReset.input}

    height: 40px;
    padding: 10px;
    padding-left: 20px;
    border-radius: 5px;
    background: var(--white-10, rgba(255, 255, 255, 0.1));
    width: 100%;

    transition: box-shadow 200ms ease;

    &:focus {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }
`;
